import { optionOperation, toFilterString, deepcopy } from './utility.js';

export function queryLayerByMII(spec, mark, index, id) {
  let o; // output
  if (mark !== undefined && index !== undefined && id !== undefined) {
    spec.layer?.forEach((layer, i) => {
      if (layer.mark?.type === mark && i == index && layer.name === id) o = i;
    });
  } else if (id !== undefined) {
    spec.layer?.forEach((layer, i) => {
      if (layer.name === id) o = i; // first
    });
  } else if (index !== undefined) {
    if (index < spec.layer?.length)
      o = index;
  } else if (mark !== undefined) {
    spec.layer?.forEach((layer, i) => {
      if (layer?.mark?.type === mark && o !== undefined) o = i; // first
    });
  }
  return o;
}
export function isLayerWithQuery(layer, li, mark, index, id) {
  if (mark !== undefined && index !== undefined && id !== undefined) {
    if (layer.mark?.type === mark && i == index && layer.name === id) return true;
    else return false;
  } else if (id !== undefined) {
    if (layer.name === id) return true;
    else return false;
  } else if (index !== undefined) {
    if (li === index) return true;
    else return false;
  } else if (mark !== undefined) {
    if (layer?.mark?.type === mark) return true;
    else return false;
  }
  return true;
};

export async function LayerTransformation(role, spec, original, specifier, action, option) {
  if (action === "add") {
    if (option?.role === "text" && option.text !== undefined) {
      spec.layer.forEach((layerItem, li) => {
        // flag
        let flag = isLayerWithQuery(layerItem, li, specifier.mark, specifier.index, specifier.id);
        if (flag) {
          if (specifier.data !== undefined) {
            let fstr = toFilterString(specifier.data)
            if (layerItem.transform === undefined) flag = false;
            else {
              if (layerItem.transform.filter(transform => {
                return transform.includes(fstr)
              }).length == 0) flag = false;
            }
          }
        }

        if (flag) {
          let new_text = {};
          if (option.text.type) {
            new_text.type = { "axis": "on-axis", "mark": "on-mark", "legend": "legend" }[option.text.type];
          }
          if (option.text.field) {
            new_text.field = option.text.field;
          }
          if (option.text.items) {
            new_text.items = option.text.items;
          }

          Object.keys(option.text).forEach(propertyKey => {
            if (["type", "field", "items"].includes(propertyKey)) return;
            if (["width", "align", "fontSize", "fontWeight", "lineHeight", "textAlign", "fontStroke", "fontColor"].includes(propertyKey)) {
              let _propertyKey = { "textAlign": "align", "fontColor": "color" }[propertyKey] || propertyKey;
              new_text.items.forEach((textElem, ti) => {
                if (option.text[propertyKey]?.constructor.name === "Array") {
                  textElem[_propertyKey] = optionOperation(textElem[_propertyKey], option.text[propertyKey][ti]);
                } else if (option.text[propertyKey] !== null) {
                  textElem[_propertyKey] = optionOperation(textElem[_propertyKey], option.text[propertyKey]);
                } else delete textElem[_propertyKey];
              })
              if (propertyKey === "width") {
                if (option.text[propertyKey] !== null) {
                  if (new_text[propertyKey] === undefined) new_text[propertyKey] = 120;
                  new_text[propertyKey] = optionOperation(new_text[propertyKey], option.text[propertyKey]);
                } else delete new_text[propertyKey];
              }
            } else if (propertyKey === "offset") {
              if (option.text[propertyKey] !== null) new_text["padding"] = optionOperation(new_text["padding"], option.text[propertyKey]);
              else delete new_text["padding"];
            } else if (propertyKey.startsWith("margin")) {
              new_text.items.forEach((textElem, ti) => {
                if (option.text[propertyKey]?.constructor.name === "Array") {
                  textElem[propertyKey] = optionOperation(textElem[propertyKey], option.text[propertyKey][ti]);
                } else if (option.text[propertyKey] !== null) {
                  textElem[propertyKey] = optionOperation(textElem[propertyKey], option.text[propertyKey]);
                } else delete textElem[propertyKey];
              })
            } else if (propertyKey === "tick") {
              if (option.text[propertyKey] === null) delete new_text.tick;
              else {
                if (new_text.tick === undefined) new_text.tick = {};
                if (option.text[propertyKey].constructor.name === "Boolean") {
                  new_text.tick = {};
                  new_text.tick.ticks = option.text[propertyKey];
                }
                else if (option.text[propertyKey].constructor.name === "Object") {
                  Object.keys(option[propertyKey]).forEach(tickKey => {
                    new_text.tick[tickKey] = option.text[propertyKey][tickKey]
                  })
                }
              }
            } else if (propertyKey === "external") {
              if (option.text[propertyKey] === null) {
                delete new_text.visibility?.["externalize"];
              } else if (option.text[propertyKey] == true) {
                if (new_text.visibility === undefined) new_text.visibility = {};
                if (new_text.visibility.externalize === undefined) new_text.visibility.externalize = {};
                if (option.text[propertyKey]) new_text.visibility.externalize.position = "bottom";
              } else if (option.text[propertyKey] == false) {
                if (new_text.visibility?.externalize !== undefined) delete new_text.visibility.externalize;
              }
            } else if (propertyKey === "numbering") {
              if (option.text[propertyKey] === null) {
                delete new_text.visibility?.externalize?.numbering;
              } else {
                if (new_text.visibility === undefined) new_text.visibility = {};
                if (new_text.visibility.externalize === undefined) new_text.visibility.externalize = {};
                if (option.text[propertyKey]) new_text.visibility.externalize.numbering = true;
              }
            } else if (!["expression", "format", "condition"].includes(propertyKey)) {
              const keymap = { "anchor": "anchorAlign" };
              let propertyKey2 = (keymap[propertyKey] ? keymap[propertyKey] : propertyKey);
              if (option.text[propertyKey] !== null) new_text[propertyKey2] = optionOperation(new_text[propertyKey2], option.text[propertyKey]);
              else delete new_text[propertyKey2];
            }
          });
          if (layerItem.text === undefined) layerItem.text = [];
          layerItem.text.push(new_text);
        }

      });
    } else if ((option?.legend !== undefined && option.legend.constructor.name === "Object") || (option?.role === "legend")) {
      // add legend
      spec.layer.forEach((layerItem, li) => {
        // flag
        let flag = true;
        if (flag) {
          if (specifier.id !== undefined) {
            if (specifier.id !== layerItem.name) flag = false;
          }
          if (specifier.mark !== undefined) {
            if (specifier.mark !== layerItem.mark.type) flag = false;
          }
          if (specifier.data !== undefined) {
            let fstr = toFilterString(specifier.data)
            if (layerItem.transform === undefined) flag = false;
            else {
              if (layerItem.transform.filter(transform => {
                return transform.includes(fstr)
              }).length == 0) flag = false;
            }
          }
        }

        if (flag) {
          let new_text = { type: "legend" };
          let legendOption = (option.role === "legend" ? option : option.legend)
          if (legendOption?.field) {
            new_text.field = legendOption?.field;
          }
          if (legendOption?.items) {
            new_text.items = legendOption?.items;
          }
          if (legendOption?.title) {
            new_text.title = legendOption?.title;
          }
          if (legendOption?.constructor.name === "Object") {
            Object.keys(legendOption)?.forEach(propertyKey => {
              if (["type", "field", "items", "role"].includes(propertyKey)) return;
              if (["width", "align", "fontSize", "fontWeight", "lineHeight", "textAlign", "fontStroke", "fontColor"].includes(propertyKey)) {
                let _propertyKey = { "textAlign": "align", "fontColor": "color" }[propertyKey] || propertyKey;
                new_text.items?.forEach((textElem, ti) => {
                  if (legendOption[propertyKey]?.constructor.name === "Array") {
                    textElem[_propertyKey] = optionOperation(textElem[_propertyKey], legendOption[propertyKey][ti]);
                  } else if (legendOption[propertyKey] !== null) {
                    textElem[_propertyKey] = optionOperation(textElem[_propertyKey], legendOption[propertyKey]);
                  } else delete textElem[_propertyKey];
                })
                if (propertyKey === "width") {
                  if (legendOption[propertyKey] !== null) {
                    if (new_text[propertyKey] === undefined) new_text[propertyKey] = 120;
                    new_text[propertyKey] = optionOperation(new_text[propertyKey], legendOption[propertyKey]);
                  } else delete new_text[propertyKey];
                }
              } else if (propertyKey === "offset") {
                if (legendOption[propertyKey] !== null) new_text["padding"] = optionOperation(new_text["padding"], option.legend[propertyKey]);
                else delete new_text["padding"];
              } else if (propertyKey.startsWith("margin")) {
                new_text.items?.forEach((textElem, ti) => {
                  if (legendOption[propertyKey]?.constructor.name === "Array") {
                    textElem[propertyKey] = optionOperation(textElem[propertyKey], legendOption[propertyKey][ti]);
                  } else if (option.text[propertyKey] !== null) {
                    textElem[propertyKey] = optionOperation(textElem[propertyKey], legendOption[propertyKey]);
                  } else delete textElem[propertyKey];
                })
              } else {
                new_text[propertyKey] = legendOption[propertyKey]
              }
            });
          }
          if (new_text.items === undefined) new_text.items = [{}];
          layerItem.text.push(new_text);
        }

      });

    } else if ((option?.tooltip !== undefined && option.tooltip.constructor.name === "Object") || (option?.role === "tooltip")) {
      let tooltipOption;
      if (option.role === "tooltip") tooltipOption = option;
      else if (option?.tooltip?.constructor.name === "Object") tooltipOption = option.tooltip;
      if (tooltipOption) {
        spec.layer.forEach((layerItem, li) => {
          // flag
          let flag = isLayerWithQuery(layerItem, li, specifier.mark, specifier.index, specifier.id);
          if (flag) {
            if (specifier.data !== undefined) {
              let fstr = toFilterString(specifier.data)
              if (layerItem.transform === undefined) flag = false;
              else {
                if (layerItem.transform.filter(transform => {
                  return transform.includes(fstr)
                }).length == 0) flag = false;
              }
            }
          }
          if (flag) {
            if (layerItem.tooltip === undefined) layerItem.tooltip = { visibility: "on-mark" };
            Object.keys(tooltipOption).forEach(propKey => {
              if (propKey !== "role") {
                let _propKey = { field: "fields" }[propKey] || propKey;
                if (tooltipOption[propKey] == null) delete layerItem.tooltip[_propKey];
                else layerItem.tooltip[_propKey] = tooltipOption[propKey];
              }
            });
            if (layerItem.tooltip.fields === undefined || layerItem.tooltip.fields.length == 0) {
              layerItem.tooltip.fields = [];
              let fields = [];
              spec?.layout?.row.forEach((f) => {
                fields.push(f.field);
              });
              spec?.layout?.column.forEach((f) => {
                fields.push(f.field);
              });
              Object.keys(layerItem.mark).forEach((enc) => {
                if (layerItem.mark[enc].field !== undefined)
                  fields.push(layerItem.mark[enc].field);
              });
              layerItem.text?.forEach((text) => {
                if (text.field !== undefined && !fields.includes(text.field)) {
                  fields.push(text.field);
                }
              });
              fields.forEach((field) => {
                layerItem.tooltip.fields.push({ field });
              });
            }
          }
        });
      }
    } else if (option?.transform !== undefined && option?.role === "transform") {
      let transform = option.transform;
      if (option.transform.constructor.name === "Object") transform = [option.transform];
      if (transform.length > 0) {
        spec.layer.forEach((layerItem, li) => {
          // flag
          let flag = isLayerWithQuery(layerItem, li, specifier.mark, specifier.index, specifier.id);
          if (flag) {
            if (specifier.data !== undefined) {
              let fstr = toFilterString(specifier.data)
              if (layerItem.transform === undefined) flag = false;
              else {
                if (layerItem.transform.filter(transform => {
                  return transform.includes(fstr)
                }).length == 0) flag = false;
              }
            }
          }
          if (flag) {
            if (!layerItem.transform) layerItem.transform = [];
            layerItem.transform.push(...transform);
          }
        });
      }
    } else if (option !== undefined && option.role === undefined) {
      if (spec.layer === undefined) spec.layer = [];
      let layerObj = {};
      // data-filter (transform)
      if (option.data !== undefined) {
        let fstr = toFilterString(option.data);
        layerObj.transform = [
          {
            "filter": fstr
          }
        ];
      }
      // mark type setting
      if (option.mark !== undefined) {
        if (option.mark.constructor.name === "String") {
          layerObj.mark = { "type": option.mark };
          Object.keys(option).forEach(propertyKey => {
            if ("color,stroke,strokeWidth,size,fill,opacity,shape,strokeDash,strokeStyle".split(",").includes(propertyKey)) {
              layerObj.mark[propertyKey] = deepcopy(option[propertyKey]);
            }
          })
        } else if (option.mark.constructor.name === "String") {
          layerObj.mark = deepcopy(option.mark);
        }
      }
      if (option.name) {
        layerObj.name = option.name;
      }
      let toAdd = (option.index || spec.layer.length || 0);
      spec.layer.splice(toAdd, 0, layerObj);
    }
  } else if (action === "swap") {
    let from = queryLayerByMII(spec, specifier?.mark || option?.from?.mark, specifier?.index || option?.from?.index, specifier?.id || option?.from?.id);
    let to = queryLayerByMII(spec, option?.to?.mark, option?.to?.index, option?.to?.id);
    if (from !== undefined && to !== undefined) {
      let from_layer = deepcopy(spec.layer[from]);
      let to_layer = deepcopy(spec.layer[to]);
      spec.layer[from] = to_layer;
      spec.layer[to] = from_layer;
    }
  } else if (action === "modify") {
    spec.layer.forEach((layerItem, li) => {
      // flag
      let flag = isLayerWithQuery(layerItem, li, specifier.mark, specifier.index, specifier.id);
      if (flag) { // further data query
        if (specifier.data !== undefined) {
          let fstr = toFilterString(specifier.data)
          if (layerItem.transform === undefined) flag = false;
          else {
            if (layerItem.transform.filter(transform => {
              return transform.includes(fstr)
            }).length == 0) flag = false;
          }
        }
      }
      if (flag && option !== undefined) {
        Object.keys(option).forEach(propKey => {
          if (propKey === "mark") {
            Object.keys(option.mark).forEach(markPropKey => {
              if (markPropKey === "type") {
                if (layerItem.mark === undefined) layerItem.mark = {};
                layerItem.mark.type = option.mark.type;
              }

              // todo;
            })
          } else if (propKey === "id" || propKey === "name") {
            layerItem.name = option[propKey];
          }
          // todo
        })
      }
    });
  } else if (action === "remove") {
    let toRemove = [];
    spec.layer.forEach((layerItem, li) => {
      // flag
      let flag = isLayerWithQuery(layerItem, li, specifier.mark, specifier.index, specifier.id);
      if (flag) { // further data query
        if (specifier.data !== undefined) {
          let fstr = toFilterString(specifier.data)
          if (layerItem.transform === undefined) flag = false;
          else {
            if (layerItem.transform.filter(transform => {
              return transform.includes(fstr)
            }).length == 0) flag = false;
          }
        }
      }
      if (flag) toRemove.push(li);
    });
    if (toRemove.length > 0) {
      toRemove.forEach(li => spec.layer[li] = undefined);
      spec.layer = spec.layer.filter(d => d !== undefined);
    }
  }
  return spec;
}